var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { transition: false, "max-width": 600, persistent: false },
      model: {
        value: _vm.opened,
        callback: function ($$v) {
          _vm.opened = $$v
        },
        expression: "opened",
      },
    },
    [
      _vm.$apollo.queries.profileDetail.loading
        ? _c("ProgressCircular")
        : _c(
            "v-container",
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("Информация о партнере"),
                  ]),
                  _vm.returnDetailsEntityType
                    ? _c(
                        "v-card-text",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                [
                                  _c("span", [_vm._v("Тип партнера")]),
                                  _c("v-text-field", {
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      disabled: "",
                                      value: _vm.returnDetailsEntityType.title,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.returnDetailsEntityType.value === "PERSONAL"
                            ? [
                                _vm.profileDetail.surname
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            _c("span", [_vm._v("Фамилия")]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value:
                                                  _vm.profileDetail.surname,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.name
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            _c("span", [_vm._v("Имя")]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value: _vm.profileDetail.name,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.patronymic
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            _c("span", [_vm._v("Отчество")]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value:
                                                  _vm.profileDetail.patronymic,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.phone
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            _c("span", [_vm._v("Телефон")]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value: _vm.profileDetail.phone,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.email
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            _c("span", [_vm._v("Эл. почта")]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value: _vm.profileDetail.email,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            : [
                                _vm.profileDetail.orgType
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("span", [
                                              _vm._v("Форма предприятия"),
                                            ]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value:
                                                  _vm.profileDetail.orgType,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.title
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("span", [
                                              _vm._v("Название организации"),
                                            ]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value: _vm.profileDetail.title,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.surname
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("span", [_vm._v("Фамилия")]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value:
                                                  _vm.profileDetail.surname,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.name
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("span", [_vm._v("Имя")]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value: _vm.profileDetail.name,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.patronymic
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("span", [_vm._v("Отчество")]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value:
                                                  _vm.profileDetail.patronymic,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.position
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("span", [_vm._v("Должность")]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value:
                                                  _vm.profileDetail.position,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.phone
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "Номер телефона для связи"
                                              ),
                                            ]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value: _vm.profileDetail.phone,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.email
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("span", [_vm._v("Эл.почта")]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value: _vm.profileDetail.email,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.inn
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("span", [
                                              _vm._v("ИНН организации"),
                                            ]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value: _vm.profileDetail.inn,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.ogrn
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("span", [
                                              _vm._v("ОГРН (ОГРНИП)"),
                                            ]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value: _vm.profileDetail.ogrn,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.legalAddress
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("span", [
                                              _vm._v("Юридический адрес"),
                                            ]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value:
                                                  _vm.profileDetail
                                                    .legalAddress,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.mailAddress
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("span", [
                                              _vm._v("Почтовый адрес"),
                                            ]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value:
                                                  _vm.profileDetail.mailAddress,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.bank
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("span", [_vm._v("Банк")]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value: _vm.profileDetail.bank,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.checkingAcc
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("span", [
                                              _vm._v("Расчетный счет"),
                                            ]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value:
                                                  _vm.profileDetail.checkingAcc,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.profileDetail.bic
                                  ? _c(
                                      "v-row",
                                      [
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "12" } },
                                          [
                                            _c("span", [_vm._v("БИК банка")]),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                dense: "",
                                                disabled: "",
                                                value: _vm.profileDetail.bic,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "v-card-actions",
                    [
                      _vm._t("actions", function () {
                        return [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "primary darken-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.close()
                                },
                              },
                            },
                            [_vm._v("OK")]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }